import "bootstrap/js/src/collapse";
import "bootstrap/js/src/dropdown";
import "bootstrap/js/src/util";

import DumDum from 'dumdum-js';
import common from './common';
import slickSlider from './slickSlider';

// DOM router
new DumDum({
  common,
  page_events: slickSlider,
  page_studio: slickSlider,
});
